import { Card } from '@/shared/ui'
import { AppIcon } from '@/shared/ui/icons'

export const WalletMovementsEmpty = () => (
  <Card>
    <Card.Body>
      <div className="flex flex-col items-center gap-3 px-4 py-10 text-center">
        <AppIcon name="empty-set" className="text-3xl text-gray-400" />
        <p className="m-0 text-sm font-bold text-gray-800">
          Nenhuma movimentação ainda
        </p>
        <p className="m-0 max-w-sm text-sm text-gray-700">
          Quando você ganhar ou usar experiência e moedas, o histórico aparecerá
          aqui.
        </p>
      </div>
    </Card.Body>
  </Card>
)
